import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import {  Save, Cancel } from '@mui/icons-material';

export default function CreateCell(props) {
    const { onSave, onCancel } = props
    const [email, _] = useState({
        email: "",
        flags: []
    })
    const [error, setError] = useState(false)
    const [emailString, setEmailString] = useState("")
    const [hasAcc, setHasAcc] = useState(email.flags.includes("ACC"))
    const [hasRecebimentos, setHasRecebimentos] = useState(email.flags.includes("RECEBIMENTOS"))
    const [hasVendas, setHasVendas] = useState(email.flags.includes("VENDAS"))
    
    const handleSave = () => {
        let flags = []
        if(emailString === ""){
            setError(true)
            return
        }
        if(hasAcc){
            flags.push("ACC")
        }
        if(hasRecebimentos){
            flags.push("RECEBIMENTOS")
        }
        if(hasVendas){
            flags.push("VENDAS")
        }
        const data = {
            email: emailString,
            flags: flags
        }
        onSave(data)
    }

    const handleDelete = () => {
        onCancel()
    }

    return (
        <TableRow
            key={email.email}
        >
            <TableCell>
            </TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">
                <TextField size='small' error={error} value={emailString} onChange={(e) => {
                    setEmailString(e.target.value)
                    setError(false)
                }}/>
            </TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasAcc(checked)} checked={hasAcc}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasVendas(checked)} checked={hasVendas}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal"><Checkbox onChange={(_, checked) => setHasRecebimentos(checked)} checked={hasRecebimentos}/></TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">
                <IconButton onClick={() => handleSave()}>
                    <Save color='success' fontSize='small'/>
                </IconButton>
            </TableCell>
            <TableCell style={{width: '40%'}} align="left" padding="normal">
                <IconButton onClick={() => handleDelete()}>
                    <Cancel color="error" fontSize='small'/>
                </IconButton>
            </TableCell>
        </TableRow>
    )
}